import script from "./OverlaySpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./OverlaySpinner.vue?vue&type=script&setup=true&lang=js"

import "./OverlaySpinner.vue?vue&type=style&index=0&id=a19e2dc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a19e2dc8"]])

export default __exports__